<script setup lang="ts">
import type { Schemas } from "#shopware";
import { getTranslatedProperty } from "@shopware/helpers";
import { SwiperSlide } from "swiper/vue";

const props = defineProps<{
	product: Schemas["Product"];
}>();

const { product } = toRefs(props);

const { loadAssociations, isLoading, productAssociations } = useProductAssociations(
	product as ComputedRef<Schemas["Product"]>,
	{
		associationContext: "cross-selling"
	}
);

loadAssociations({
	method: "post",
	searchParams: {
		associations: {
			cover: {
				associations: {
					media: {}
				}
			}
		}
	}
});
</script>

<template>
	<section class="bg-sand" v-if="!isLoading && productAssociations.length > 0">
		<Container class="py-8 flex flex-col gap-8">
			<div class="flex flex-col gap-4" v-for="association in productAssociations" :key="association.streamId">
				<Typography variant="h2">
					{{ getTranslatedProperty(association.crossSelling, "name") }}
				</Typography>
				<KippieCarousel :centered="false" pagination-type="bullets" :space="24">
					<SwiperSlide
						v-for="crossSellProduct in association.products"
						:key="crossSellProduct.id"
						class="max-w-[250px] !h-auto"
					>
						<ListingProductCard :product="crossSellProduct" />
					</SwiperSlide>
				</KippieCarousel>
			</div>
		</Container>
	</section>
</template>
